/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorTypeHelper } from 'utils/colorUtility';
import BackgroundImage from 'components/Core/BackgroundImage';

export const SectionLayout = ({
  children,
  contentBelowSection,
  backgroundImg,
  backgroundImageTypeWithPosition,
  backgroundColor,
  gradientDirection,
  innerContainerStyles,
  type,
  ...otherProps
}) => {
  const bgColor = colorTypeHelper[backgroundColor];

  const isGatsbyBgImage = backgroundImg?.gatsbyImageData;
  const isNonGatsbyBgImage = !isGatsbyBgImage && (backgroundImg?.file?.url || backgroundImg);

  return (
    <Layout
      bgColor={bgColor}
      bgImg={isNonGatsbyBgImage}
      contentBelowSection={contentBelowSection}
      gradientDirection={gradientDirection}
      {...otherProps}
      className={`${otherProps.className} section-layout--container`}
    >
      {isGatsbyBgImage && (
        <BackgroundImage image={backgroundImg} loading={type === 'hero' ? 'eager' : 'lazy'} />
      )}
      <InnerContainer
        className={`section-layout--inner-container ${innerContainerStyles}`}
        contentBelowSection={contentBelowSection}
      >
        {children}
      </InnerContainer>
    </Layout>
  );
};

SectionLayout.propTypes = {
  backgroundImg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  backgroundColor: PropTypes.string,
  backgroundImageTypeWithPosition: PropTypes.string,
  contentBelowSection: PropTypes.bool,
};

const InnerContainer = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0px auto;
  padding-top: 50px;
  padding-bottom: ${({ contentBelowSection }) => (contentBelowSection ? '0px' : '50px')};
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
`;

const Layout = styled.div`
  background-image: ${({ bgImg, gradientDirection }) => {
    return `${
      gradientDirection
        ? `linear-gradient(${gradientDirection.toLowerCase()}, rgba(0,0,0,1) 0%, rgba(0,212,255,0) 78%),`
        : ''
    }
    ${bgImg ? `url(${bgImg})` : ''}`;
  }};
  background-color: var(${({ bgColor }) => bgColor});
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: ${({ contentBelowSection }) => (contentBelowSection ? 'visible' : 'hidden')};
  z-index: 0;

  .blue-light-corner-right {
    position: absolute;
    right: 0;
    z-index: -1;
  }

  .blue-light-side-right {
    position: absolute;
    right: 20%;
    z-index: -1;
  }
  .blue-dark-corner-left {
    position: absolute;
    left: 0;
    z-index: -1;
  }
  .blue-dark-corner-right {
    position: absolute;
    z-index: -1;
    right: 0;
  }
  ${({ bgImg }) =>
    bgImg &&
    `@media (max-width: 575px) {
      background-image:
      url(${bgImg})
      background-position: center;
      background-size: cover;
    }`}
`;
